/* The docs page: the section being read is marked in the list on the left. */

const links = new Map<string, HTMLAnchorElement>();
for (const a of document.querySelectorAll<HTMLAnchorElement>(".toc a[href^='#']")) links.set(a.hash.slice(1), a);

const headings = [...document.querySelectorAll<HTMLElement>("article h2[id], article h3[id]")].filter((h) => links.has(h.id));

function mark() {
  // the last heading above a line a quarter of the way down the window (below where a link puts its heading)
  const line = Math.max(120, window.innerHeight / 4);
  let current = headings[0];
  for (const h of headings) {
    if (h.getBoundingClientRect().top <= line) current = h;
    else break;
  }
  for (const [id, a] of links) a.classList.toggle("here", id === current?.id);
}

if (headings.length) {
  let queued = false;
  window.addEventListener("scroll", () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; mark(); });
  }, { passive: true });
  // and again once pictures above have loaded and moved the text, or a link inside the page was followed
  window.addEventListener("load", mark);
  window.addEventListener("hashchange", () => requestAnimationFrame(mark));
  mark();
}
